// Croma header — scroll lift, hover-intent mega/dropdowns, expanding search, mobile drawer.
(function () {
  function init() {
    var hdr = document.querySelector('[data-croma-header]');
    if (!hdr) return;

    // Scroll lift — shadow once the page scrolls.
    var onScroll = function () { hdr.classList.toggle('is-scrolled', window.scrollY > 8); };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });

    // Mega / dropdown hover-intent — keeps a panel open while the cursor crosses the
    // gap from the nav item down into the panel (grace period before closing).
    var menuItems = hdr.querySelectorAll('.croma-hdr__navitem--mega, .croma-hdr__navitem--has');
    var hoverTimer;
    function closeAllPanels() {
      for (var i = 0; i < menuItems.length; i++) menuItems[i].classList.remove('is-open');
    }
    menuItems.forEach(function (item) {
      item.addEventListener('mouseenter', function () {
        clearTimeout(hoverTimer);
        closeAllPanels();
        item.classList.add('is-open');
      });
      item.addEventListener('mouseleave', function () {
        clearTimeout(hoverTimer);
        hoverTimer = setTimeout(closeAllPanels, 200);
      });
    });

    // Expanding search
    var searchToggle = hdr.querySelector('.croma-hdr__searchtoggle');
    var searchClose = hdr.querySelector('.croma-hdr__searchclose');
    // Horizon's predictive-search snippet renders its own input (#croma-hdr-search-input).
    // Fall back to any search field inside the desktop search panel.
    var searchInput = hdr.querySelector('#croma-hdr-search-input')
      || hdr.querySelector('.croma-hdr__searchpanel input[type="search"]');
    function openSearch() {
      hdr.classList.add('croma-hdr--search');
      if (searchToggle) searchToggle.setAttribute('aria-expanded', 'true');
      if (searchInput) setTimeout(function () { searchInput.focus(); }, 80);
    }
    function closeSearch() {
      hdr.classList.remove('croma-hdr--search');
      if (searchToggle) searchToggle.setAttribute('aria-expanded', 'false');
    }
    if (searchToggle) searchToggle.addEventListener('click', function () {
      if (hdr.classList.contains('croma-hdr--search')) closeSearch(); else openSearch();
    });
    if (searchClose) searchClose.addEventListener('click', closeSearch);
    document.addEventListener('click', function (e) {
      if (!hdr.classList.contains('croma-hdr--search')) return;
      if (e.target.closest('.croma-hdr__searchpanel') || e.target.closest('.croma-hdr__searchtoggle')) return;
      closeSearch();
    });

    // Mobile drawer
    var burger = hdr.querySelector('.croma-hdr__burger');
    var scrim = hdr.querySelector('.croma-hdr__scrim');
    function openDrawer() {
      hdr.classList.add('croma-hdr--open');
      if (burger) burger.setAttribute('aria-expanded', 'true');
      document.documentElement.style.overflow = 'hidden';
    }
    function closeDrawer() {
      hdr.classList.remove('croma-hdr--open');
      if (burger) burger.setAttribute('aria-expanded', 'false');
      document.documentElement.style.overflow = '';
    }
    if (burger) burger.addEventListener('click', function () {
      if (hdr.classList.contains('croma-hdr--open')) closeDrawer(); else openDrawer();
    });
    if (scrim) scrim.addEventListener('click', closeDrawer);
    var drawer = hdr.querySelector('.croma-hdr__drawer');
    if (drawer) drawer.addEventListener('click', function (e) {
      if (e.target.closest('a')) closeDrawer();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { closeSearch(); closeDrawer(); closeAllPanels(); }
    });
    window.addEventListener('resize', function () {
      if (window.innerWidth > 900 && hdr.classList.contains('croma-hdr--open')) closeDrawer();
    });
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
